/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Event_Metrics_Duration_TitleInputs */

const en_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} Seconds (Total Duration)`)
};

const fr_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} Secondes (duree totale)`)
};

const de_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} Sekunden (Gesamtdauer)`)
};

const it_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} Secondi (Durata totale)`)
};

const ru_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} секунд (общая продолжительность)`)
};

const es_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} Segundos (Duración total)`)
};

const zh_cn2_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} 秒（总持续时间）`)
};

const ja_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} 秒（合計時間）`)
};

const hi_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} सेकंड (कुल अवधि)`)
};

const pt_pt2_event_metrics_duration_title = /** @type {(inputs: Event_Metrics_Duration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} Segundos (Duração Total)`)
};

/**
* | output |
* | --- |
* | "{duration} Seconds (Total Duration)" |
*
* @param {Event_Metrics_Duration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_duration_title = /** @type {((inputs: Event_Metrics_Duration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Duration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_duration_title(inputs)
	if (locale === "de") return de_event_metrics_duration_title(inputs)
	if (locale === "it") return it_event_metrics_duration_title(inputs)
	if (locale === "ru") return ru_event_metrics_duration_title(inputs)
	if (locale === "es") return es_event_metrics_duration_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_duration_title(inputs)
	if (locale === "ja") return ja_event_metrics_duration_title(inputs)
	if (locale === "hi") return hi_event_metrics_duration_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_duration_title(inputs)
	return en_event_metrics_duration_title(inputs)
});